import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RequestAudit from "@/pages/RequestAudit";

export const Route = createFileRoute("/es/solicita-tu-auditoria")({
  head: () => buildRouteHead("/es/solicita-tu-auditoria"),
  component: RequestAudit,
});

